module.exports = __webpack_public_path__ + "img/fapiao.4ac4d2d6.svg";